import app from 'flarum/forum/app';
export default function loadOpportunities(type) {
  const query = new URLSearchParams();
  if (type) {
    query.set('type', type);
  }
  return app.request({
    method: 'GET',
    url: `${app.forum.attribute('apiUrl')}/devconnect/opportunities?${query.toString()}`
  });
}
flarum.reg.add('devconnect-jobs', 'forum/service/opportunityApi', loadOpportunities);